import {
  StorageUtility,
  StorageType,
  StorageUtilityOptions,
} from './storage.utility';

export class SessionStorageUtility extends StorageUtility {
  constructor(storageUtilityOptions?: StorageUtilityOptions) {
    super(StorageType.sessionStorage, storageUtilityOptions);
  }
}
